import { OnInit } from '@angular/core';
import { Component, Injector, Input, Output } from '@angular/core';
import { MatFormFieldControl } from '@angular/material';
import { AbstractSelectComponent } from '@mctic/ng-core';
import { Observable } from 'rxjs';
import { TipoClasse } from './../../model/tipo-classe.model';
import { TipoClasseService } from './../../../service/tipo-classe.service';
import { trackByCodigo } from '../../utilities/track-by-fn';

@Component({
  selector: 'app-select-tipos-classe',
  providers: [{provide: MatFormFieldControl, useExisting: TipoClasseSelectComponent}],
  template: `
    <mat-select
      [formControl]="formControl"
      [compareWith]="trackByCodigo"
      (selectionChange)="onSelectionChange($event)"
    >
      <mat-option *ngIf="!noSelectionLabel"></mat-option>
      <mat-option [value]="getOptionValue(option)" *ngFor="let option of tiposClasse | async">{{option.nomeClasse}}</mat-option>
    </mat-select>
  `
})
export class TipoClasseSelectComponent extends AbstractSelectComponent<TipoClasse> implements OnInit {

  protected trackByCodigo = trackByCodigo;
  protected tiposClasse: Observable<TipoClasse[]>;
  @Input() tipoClasse: boolean;

  constructor(injector: Injector, private tipoClasseService: TipoClasseService) {
    super(injector);
  }

  ngOnInit(): void {
    if(this.tipoClasse === undefined) {
      this.tiposClasse = this.tipoClasseService.obterTodos();
    } else {
      this.tiposClasse = this.tipoClasseService.obterTipoClassePorProjeto(this.tipoClasse);
    }
  }
}
